import {Box, Button, Divider, Drawer, IconButton, Stack, styled, Tooltip, Typography} from "@mui/material";
import {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {CloseRounded, ContentCutRounded, DeleteRounded, DownloadRounded, EditRounded, FolderRounded, FolderZipRounded, InfoRounded, KeyboardArrowLeftRounded, KeyboardArrowRightRounded, ShareRounded, TagRounded} from "@mui/icons-material";
import ConfirmDialog from "../../common/confirmDialog";
import InputFieldModal from "./inputFieldModal";
import TransferModal from "./transferModal";
import {farsiDate, farsiHour} from "../../../lib/commonFunctions/dateConvertor";
import {convertSize} from "../../../lib/commonFunctions/convertSize";
import {getImageFile} from "../../../lib/services/drive";
import FileTag from "../../../theme/components/FileTag";
import {compressString} from "../../../lib/commonFunctions/compressString";
import ProgressButton from "../../common/progressButton";

const File = (props) => {

    const [infoDrawerOpen, setInfoDrawerOpen] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [transferModalOpen, setTransferModalOpen] = useState(false);

    const {file = {}, files, selected, setSelectedItem, openedDrawer, setOpenedDrawer = () => null, onDelete, onRename, onMoved, onDownload, onDownloadZip, onDownloadCancel, downloadProgress, downloadFailed, downloadController, onShare, onAddTag, onRemoveTag, pending, ...restProps} = props;
    const {type, name} = file;

    const isFolder = Boolean(type === "folder");
    const isOpened = Boolean(props?.className === "Mui-opened");
    const selectedIndex = files?.indexOf(file);

    const navigate = useNavigate();

    const handleOpenInfoDrawer = (boolean) => {
        if (boolean === true) {
            setInfoDrawerOpen(true);
            setSelectedItem(file);
        } else {
            setInfoDrawerOpen(false);
            setSelectedItem(null);
            setOpenedDrawer(false);
        }
    }
    const handleFolderDoubleClick = (e) => {
        navigate(`/drive/${file.id}`);
    }

    const handleGotoPrev = () => {
        if (selectedIndex > 0) {
            const newIndex = selectedIndex - 1;
            setInfoDrawerOpen(false)
            setOpenedDrawer(files[newIndex].id);
            setSelectedItem(files[newIndex]);
        }
    }
    const handleGotoNext = () => {
        if (selectedIndex >= 0 && selectedIndex < (files.length - 1)) {
            const newIndex = selectedIndex + 1;
            setInfoDrawerOpen(false)
            setOpenedDrawer(files[newIndex].id);
            setSelectedItem(files[newIndex]);
        }
    }

    return (
        <>
            <ItemContainer className={selected ? "Mui-selected" : ""} {...restProps}>
                <Box width={1} height={1} borderRadius="inherit">
                    {isFolder
                        ?
                        <>
                            <Link to={`/drive/${file.id}`}>
                                <Box onClick={(e) => e.preventDefault()} onDoubleClick={handleFolderDoubleClick} sx={{ width: 1, height: 1, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", color: theme => theme.palette.grey.dark }}>
                                    <FolderRounded className="MuiFileIcon-root"/>
                                    <Box mt={1} px={{ xs: 1, lg: 2 }} width={1}>
                                        <Typography color="text.primary" className="MuiFileName-root line-clamp" textAlign="center">{name}</Typography>
                                    </Box>
                                </Box>
                            </Link>
                            <Box className="MuiFileActions-root">
                                <Tooltip title="مشخصات">
                                    <IconButton onClick={(e) => {e.stopPropagation();handleOpenInfoDrawer(true);props.handleSelect(e);}} sx={{ p: 0 }}><InfoRounded color='inherit'/></IconButton>
                                </Tooltip>
                            </Box>
                        </>
                        :
                        <Box width={1} height={1} display="flex" alignItems="center" justifyContent="center" flexDirection="column" borderRadius="inherit">
                            {renderThumb(file, handleOpenInfoDrawer, isOpened, (e) => props.handleSelect(e))}
                        </Box>
                    }
                </Box>
            </ItemContainer>
            <Drawer open={infoDrawerOpen || openedDrawer === file.id} onClose={() => handleOpenInfoDrawer(false)} anchor="right" PaperProps={{ sx: {p: {xs: 2, lg: 2.5}, width: {xs: "75%", lg: "30%", xl: "25%"}} }}>
                <Box display="flex" justifyContent="flex-end">
                    <IconButton onClick={() => handleOpenInfoDrawer(false)}><CloseRounded/></IconButton>
                </Box>
                {!isFolder && (
                    <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
                        <IconButton onClick={handleGotoPrev} disabled={selectedIndex <= 0} color="primary">
                            <KeyboardArrowRightRounded/>
                        </IconButton>
                        <Typography fontSize={{ xs: "1.25rem" }} fontWeight={500} textAlign="center">{name}</Typography>
                        <IconButton onClick={handleGotoNext} disabled={selectedIndex >= (files?.length - 1)} color="primary">
                            <KeyboardArrowLeftRounded/>
                        </IconButton>
                    </Box>
                )}
                <Box mt={3}>
                    <File file={{...file, thumbnail: getImageFile(file.fileHashId)}} className="Mui-opened"/>
                    <Box mt={3}>
                        {isFolder && (
                            <Typography fontSize={{ xs: "1.25rem" }} fontWeight={500}>{name}</Typography>
                        )}
                        <Stack mt={2} spacing={6}>
                            <Box>
                                <Stack p={0} spacing={2} divider={<Divider/>}>
                                    <Typography fontWeight={500}>اطلاعت</Typography>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>نوع فایل</Typography>
                                        <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{type ? type.toUpperCase() : 'نامشخص'}</Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>تاریخ ایجاد</Typography>
                                        <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{farsiHour(file.createdAt) + " - " + farsiDate(file.createdAt)}</Typography>
                                    </Box>
                                    {!isFolder && (
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>حجم</Typography>
                                            <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{convertSize(file.size, {farsi: true})}</Typography>
                                        </Box>
                                    )}
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>وضعیت اشتراک</Typography>
                                        <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{file.isShared ? "اشتراک گذاری شده" : "اشتراک گذاری نشده"}</Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>مبلغ فایل</Typography>
                                        <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{file.price ? file.price : "رایگان"}</Typography>
                                    </Box>
                                    {file.isShared && (
                                        <>
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>کد اشتراک گذاری</Typography>
                                                <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{file.shareAddress ? file.shareAddress : "نامشخص"}</Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>رمز اشتراک گذاری</Typography>
                                                <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{file.sharePassword ? file.sharePassword : "نامشخص"}</Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>تاریخ انقضای اشتراک</Typography>
                                                <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{file.shareExpire ? `${farsiHour(file.shareExpire)} - ${farsiDate(file.shareExpire)}` : "نامشخص"}</Typography>
                                            </Box>
                                        </>
                                    )}
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>تعداد دانلود</Typography>
                                        <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{file.downloadCount ? file.downloadCount : "۰"}</Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>تعداد لایک</Typography>
                                        <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>{file.likesCount ? file.likesCount : "۰"}</Typography>
                                    </Box>
                                    <Box display="flex" alignItems="baseline" justifyContent="space-between" flexWrap="wrap" rowGap={1} columnGap={1}>
                                        <Typography color="grey.dark" fontSize={{ xs: ".9rem", lg: ".975rem" }} fontWeight={300}>تگ های فایل</Typography>
                                        {file?.tags?.length
                                            ?
                                            <Stack direction="row" alignItems="center" rowGap={1} columnGap={1} flexWrap="wrap">
                                                {file.tags.map((t, ind) => (
                                                    <FileTag key={ind} label={t.name} onDelete={() => onRemoveTag(file.id, t.name)}/>
                                                ))}
                                            </Stack>
                                            :
                                            <Typography fontSize={{ xs: ".9rem", lg: ".975rem" }}>بدون تگ</Typography>
                                        }
                                    </Box>
                                </Stack>
                            </Box>
                            <Box>
                                <Stack p={0} spacing={2} divider={<Divider/>}>
                                    <Typography fontWeight={500}>توضیحات</Typography>
                                    <Typography fontSize={{ xs: ".9rem" }}>{file.description ? file.description : "بدون توضیح"}</Typography>
                                </Stack>
                            </Box>
                        </Stack>
                    </Box>
                </Box>
                <Stack mt={3} spacing={2}>
                    {!isFolder
                        ?
                        <>
                            <ProgressButton
                                downloading={pending === ('downloading'+file.id)}
                                onClick={onDownload}
                                progress={downloadProgress}
                                isFailed={downloadFailed}
                                onCancel={() => onDownloadCancel(file.id, file.type)}
                                variant="contained"
                                color="success" fullWidth
                                startIcon={<DownloadRounded/>}
                                sx={{ py: 1.5 }} disableElevation>دانلود</ProgressButton>
                            <Button onClick={onShare} variant="contained" color="grey" fullWidth startIcon={<ShareRounded/>} sx={{ py: 1.5 }} disableElevation>اشتراک گذاری / ارسال مجدد</Button>
                            <Button onClick={onAddTag} variant="contained" fullWidth startIcon={<TagRounded/>} sx={{ py: 1.5 }} disableElevation>افزودن تگ</Button>
                        </>
                        :
                        <>
                            <Button onClick={() => setTransferModalOpen(true)} variant="contained" color="grey" fullWidth startIcon={<ContentCutRounded/>} sx={{ py: 1.5 }} disableElevation>انتقال</Button>
                            <Button onClick={() => setEditModalOpen(true)} variant="contained" color="info" fullWidth startIcon={<EditRounded/>} sx={{ py: 1.5 }} disableElevation>تغییر نام</Button>
                            <Button onClick={onShare} variant="contained" color="grey" fullWidth startIcon={<ShareRounded/>} sx={{ py: 1.5 }} disableElevation>اشتراک گذاری</Button>
                        </>
                    }
                    {isFolder
                        ?
                        <ProgressButton
                            downloading={pending === ("downloadingZip" + file.id)}
                            progress={file.downloadProgress}
                            // isCompleted={file.downloadCompleted}
                            isFailed={file.downloadFailed}
                            onClick={onDownloadZip}
                            onCancel={() => onDownloadCancel(file.id, "folder")}
                            color="success" variant="contained"
                            fullWidth startIcon={<FolderZipRounded/>}
                            sx={{ py: 1.5 }} disableElevation>دانلود به صورت فشرده</ProgressButton>
                        :
                        <ProgressButton
                            downloading={pending === ("downloadingZip" + file.id)}
                            progress={downloadProgress}
                            isFailed={downloadFailed}
                            onClick={onDownloadZip}
                            onCancel={() => onDownloadCancel(file.id, type)}
                            color="success" variant="contained"
                            fullWidth startIcon={<FolderZipRounded/>}
                            sx={{ py: 1.5 }} disableElevation>دانلود به صورت فشرده</ProgressButton>
                    }
                    <Button onClick={() => setConfirmDialogOpen(true)} variant="contained" color="error" fullWidth startIcon={<DeleteRounded/>} sx={{ py: 1.5 }} disableElevation>حذف</Button>
                    <ConfirmDialog
                        open={confirmDialogOpen}
                        onClose={() => setConfirmDialogOpen(false)}
                        onConfirm={async() => {await onDelete(file.id); setConfirmDialogOpen(false)}}
                        title="آیا مطمئنی که میخوای حذف کنی؟"
                        description="هنگامی که فایل حذف بشه دیگه نمیتونی بازیابیش کنی"
                        color="error" pending={pending}/>
                    <InputFieldModal
                        open={editModalOpen}
                        onClose={() => setEditModalOpen(false)}
                        onConfirm={async (value) => {await onRename(value); setEditModalOpen(false)}}
                        title="تغییر نام" pending={pending}
                        inputProps={{ label: "نام جدید", placeholder: "لطفا نام جدید را وارد کنید" }}/>
                </Stack>
                {/* Folder Transfer */}
                <TransferModal
                    open={transferModalOpen}
                    onClose={() => setTransferModalOpen(false)}
                    foldersId={[file.id]}
                    onConfirm={ async (folderId) => {await onMoved([file.id], folderId); setTransferModalOpen(false)}}/>
            </Drawer>
        </>
    )
}
export default File;

export const ItemContainer = styled(Box)(({theme}) => ({
    position: "relative",
    height: "35vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    background: theme.palette.background.box,
    border: `1px solid ${theme.palette.grey.light+80}`,
    borderRadius: 16,
    userSelect: "none",
    cursor: "pointer",
    "& .MuiFileIcon-root": {
        fontSize: "2.5rem",
        color: theme => theme.palette.grey.dark
    },
    "& .MuiFileActions-root": {
        padding: 12,
        position: "absolute",
        top: 0,
        left: 0,
        color: theme.palette.grey.dark
    },
    "& .MuiFileIconSvg-root": {
        width: "3rem",
        height: "3rem",
    },
    [theme.breakpoints.up('md')]: {
        height: "25vw",
    },
    [theme.breakpoints.up('lg')]: {
        height: "15vw",
    },
    [theme.breakpoints.up('xl')]: {
        height: "10vw",
    },
    "&.Mui-opened": {
        height: "50vw",
        background: theme.palette.grey.main,
        borderRadius: 10,
        cursor: "initial",
        "& .MuiFileActions-root,& .MuiFileName-root": {display: "none"},
        "& .MuiFileIcon-root": {
            fontSize: "3.5rem"
        },
        "& .MuiFileIconSvg-root": {
            width: "5rem",
            height: "5rem",
        },
        "& .MuiFileThumb-root": {
            objectFit: "contain!important",
        },
        [theme.breakpoints.up('lg')]: {
            height: "20vw",
        },
        [theme.breakpoints.up('xl')]: {
            height: "15vw",
        },
    },
    "&.Mui-selected": {
        border: `2px solid ${theme.palette.primary.dark}`
    },
}));
const renderThumb = (file, setInfoDrawerOpen, isOpened, handleSelect) => {

    const {type, name} = file;

    const Actions = () => {
        return (
            <Box className="MuiFileActions-root" sx={{ display: "flex", alignItems: "center", gap: 1, width: 1, background: theme => theme.palette.background.box+"ba", borderTopRightRadius: "inherit", borderTopLeftRadius: "inherit" }}>
                <Tooltip title="مشخصات">
                    <IconButton onClick={(e) => {e.stopPropagation();setInfoDrawerOpen(true);handleSelect(e);}} sx={{ p: 0 }}><InfoRounded color='inherit'/></IconButton>
                </Tooltip>
                <Typography color="text.primary" className="line-clamp">{compressString(name, 16)}</Typography>
            </Box>
        )
    }

    switch (type) {
        // Images
        case 'jpg':
        case 'jpeg':
        case 'gif':
        // case 'svg':
        case 'png':
            return (
                <>
                    <Box component="img" className="MuiFileThumb-root" alt="cover" src={file.thumbnail} width={1} height={1} sx={{objectFit: "cover", borderRadius: "inherit"}}/>
                    <Actions/>
                </>
            )

        // Videos
        // case 'mp4':
        // case 'webm':
        // case 'ogg': {
        //     return (
        //         <>
        //             <Box component="video" alt="cover" width={1} height={1} sx={{objectFit: "cover", borderRadius: "inherit"}} controls={isOpened} muted>
        //                 <source src={file.src} type="video/mp4"/>
        //                 <source src={file.src} type="video/ogg"/>
        //                 Your browser does not support the video tag.
        //             </Box>
        //             {!isOpened && (
        //                 <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}><PlayCircleFilledRounded sx={{ color: "#fff" }} fontSize="large"/></Box>
        //             )}
        //             <Actions/>
        //         </>
        //     )
        // }

        // Others
        default: return <>
            <Box className="MuiFileIconSvg-root">
                <UnsupportedFile fileType={type}/>
            </Box>
            <Typography className="MuiFileName-root line-clamp" mt={1} textAlign="center">{compressString(name, 16)}</Typography>
            <Box className="MuiFileActions-root">
                <Tooltip title="مشخصات">
                    <IconButton onClick={(e) => {e.stopPropagation(); setInfoDrawerOpen(true);handleSelect(Object.assign(e, {force: true}));}} sx={{ p: 0 }}><InfoRounded color='inherit'/></IconButton>
                </Tooltip>
            </Box>
        </>

    }
}
const UnsupportedFile = ({fileType}) => {

    const File = ({name}) => <Box component="img" alt="icon" src={`/assets/image/icon/file/${name}`} width={1} height={1} sx={{ objectFit: "contain" }}/>

    switch (fileType) {
        case 'ai': return <File name="ai.svg"/>
        case 'avi': return <File name="avi.svg"/>
        case 'doc': return <File name="doc.svg"/>
        case 'mkv': return <File name="mkv.svg"/>
        case 'pdf': return <File name="pdf.svg"/>
        case 'ppt': return <File name="ppt.svg"/>
        case 'psd': return <File name="psd.svg"/>
        case 'txt': return <File name="txt.svg"/>
        case 'xls': return <File name="xls.svg"/>
        case 'zip': return <File name="zip.svg"/>
        case 'mp3': return <File name="mp3.svg"/>
        case 'svg': return <File name="svg.svg"/> // temp
        default: return <File name="file.svg"/>
    }
}
